module.exports = __webpack_public_path__ + "img/video2.8471750c.jpg";